var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Tab, Tabs as MuiTabs, Typography } from '@mui/material';
import { SupportedLanguages } from '../../locales';
var Tabs = styled(MuiTabs)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    min-height: 24px;\n  }\n  button.MuiTab-root {\n    min-width: 50px;\n    flex-grow: 0;\n    padding: 0 10px;\n    min-height: 24px;\n  }\n"], ["\n  && {\n    min-height: 24px;\n  }\n  button.MuiTab-root {\n    min-width: 50px;\n    flex-grow: 0;\n    padding: 0 10px;\n    min-height: 24px;\n  }\n"])));
var LanguageTab = function (_a) {
    var title = _a.title, language = _a.language, onChange = _a.onChange;
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "subtitle1" }, title),
        React.createElement(Tabs, { value: language, onChange: onChange, variant: "fullWidth", "aria-label": "language tab" }, SupportedLanguages.map(function (lang) { return (React.createElement(Tab, { key: lang, label: lang, value: lang })); }))));
};
export default LanguageTab;
var templateObject_1;
